import PropTypes from 'prop-types';

const RESERVABLE_LOCATION_PROP_TYPE = PropTypes.shape({
  location_id: PropTypes.string,
  location_type: PropTypes.string,
  location_name: PropTypes.string,
});

const LOCATION_PROP_OBJECT = {
  location_id: PropTypes.string,
  location_type: PropTypes.string,
  location_type_category: PropTypes.string,
  types_in_subtree: PropTypes.arrayOf(PropTypes.string),
  location_parent_id: PropTypes.string,
  location_parent_type: PropTypes.string,
  location_name: PropTypes.string,
  location_path: PropTypes.arrayOf(
    PropTypes.shape({
      location_id: PropTypes.string,
      location_type: PropTypes.string,
    })
  ),
  location_attributes: PropTypes.shape({
    description: PropTypes.string,
    id: PropTypes.string,
    name: PropTypes.string,
    parent_id: PropTypes.string,
    type: PropTypes.string,
  }),
  location_can_run_transactions: PropTypes.bool,
  location_legacy_id: PropTypes.string,
  location_children_count: PropTypes.number,
  location_description: PropTypes.string,
  location_state_code: PropTypes.string,
  location_agency_name: PropTypes.string,
  campsites: PropTypes.arrayOf(RESERVABLE_LOCATION_PROP_TYPE),
  tours: PropTypes.arrayOf(RESERVABLE_LOCATION_PROP_TYPE),
  has_lottery: PropTypes.bool,
  has_cooperators: PropTypes.bool,
  is_commercially_managed: PropTypes.bool,
  has_park_pass: PropTypes.bool,
};

export const LOCATION_PROP_TYPE = PropTypes.shape(LOCATION_PROP_OBJECT);
LOCATION_PROP_TYPE.location_detailed_path = PropTypes.arrayOf(LOCATION_PROP_TYPE);

export const LOCATION_PICKER_ROW_PROP_TYPE = PropTypes.shape({
  ...LOCATION_PROP_OBJECT,
  id: PropTypes.string,
  parentId: PropTypes.string,
});
